import { render } from "./DataKeyIconItem.vue?vue&type=template&id=3fb4f0b2&scoped=true"
import script from "./DataKeyIconItem.vue?vue&type=script&lang=ts"
export * from "./DataKeyIconItem.vue?vue&type=script&lang=ts"

import "./DataKeyIconItem.vue?vue&type=style&index=0&id=3fb4f0b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fb4f0b2"

export default script